var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},_vm._l((_vm.courseList),function(item,i){return _c('div',{key:i,staticClass:"item",on:{"click":function($event){return _vm.goTo(item.to)}}},[_c('img',{staticClass:"banner",attrs:{"src":require("@/assets/course-banner.png"),"alt":""}}),_c('h3',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }